<template>
  <div
    data-testid="team-jersey"
    :class="[layoutClass, classes.container, 'team-jersey']"
  >
    <div :class="classes.body">
      <svg style="width: 100%; height: 100%;" viewBox="0 0 312 312">
        <defs>
          <radialGradient
            id="no_radialGradient-1"
            cx="50%"
            cy="0%"
            fx="50%"
            fy="0%"
            r="99.24%"
            gradientTransform="matrix(0 1 -.6221 0 .5 -.5)"
          >
            <stop stopOpacity=".42" offset="0%" />
            <stop stopOpacity=".55" offset="100%" />
          </radialGradient>

          <path
            id="no_path-1"
            d="M97.75 274.21h-.05c43.2-.1 73.13-1.48 89.77-4.13-1.07-32.56-1.42-53.16-1.06-61.8l.05-1.17c.55-12.57 1.54-25.25 1.03-46.2-.22-12.15 2.97-34.04 2.17-36.65a19.64 19.64 0 011.55-1.93v-2.42c.95-1.22 4.24-9.09 4.24-10.52-1.56-.86-7.18-2.75-9.38-8.65-2.2-5.9-7.8-25.12-9.28-29.88-1.48-4.75-3.97-15.4-3.97-32.95-.73-14.59-1.42-19-4.04-19.87-2.63-.87-19.13-6.32-29.59-11.18-1.08-.5-1.69-.72-4.03-1.25-.77-1.3-3.86-3.56-5.72-5.37-5.98-1.3-9.3 3.06-31.71 3.07C75.3 3.3 72-1.06 66.02.24c-1.86 1.81-4.96 4.07-5.73 5.37-2.34.53-2.94.75-4.03 1.25-10.45 4.86-26.96 10.31-29.58 11.18-2.63.88-3.32 5.28-4.04 19.87 0 17.55-2.5 28.2-3.97 32.95-1.48 4.76-7.1 23.98-9.3 29.88-2.19 5.9-7.8 7.79-9.37 8.65 0 1.43 3.3 9.3 4.24 10.52v2.42c.18.15.7.8 1.55 1.93-.8 2.6 2.4 24.5 2.17 36.64-.52 21.6.54 34.41 1.08 47.37.36 8.65.01 29.25-1.05 61.8 16.63 2.66 46.56 4.04 89.76 4.14h-.05.05z"
          />
        </defs>

        <g fill="none" fillRule="evenodd">
          <g>
            <mask id="no_mask-1" fill="#fff">
              <use xlink:href="#no_path-1" />
            </mask>

            <use
              transform="translate(58 20)"
              :fill="teamColors?.jersey.background || '#fff'"
              xlink:href="#no_path-1"
            />

            <g>
              <g>
                <path
                  d="M155.76 288.84c-37.08 0-60.1 0-89.76-3.84v4.84c28.65 4.71 59 4.14 89.76 4.14 30.79 0 61.12.57 89.77-4.14V285c-32.73 3.83-52.7 3.84-89.77 3.84"
                  fillOpacity=".1"
                  fill="#E6E6E6"
                />
                <path
                  d="M179.43 20.84c3.56-.87 6.15-1.06 7.76-.58 1.14 1.27 1.61 3.32 1.61 5.17-1.6-.52-5.1 1.22-9.2 2.02-7.27 1.67-15.75 2.18-24.4 2.18h.6-.6.6c-8.65 0-17.13-.51-24.4-2.18-4.1-.8-7.59-2.54-9.2-2.02 0-1.85.47-3.9 1.61-5.17 1.61-.48 4.2-.29 7.76.58 6.3 1.63 14.28 2.46 23.93 2.48 9.66-.02 17.63-.85 23.93-2.48z"
                  fillOpacity=".3"
                  fill="#000"
                />
                <path
                  d="M127.02 6.97c1.84-.58 3.2-.8 3.76-.54.3 1.31-.05 5.46-2.3 10.74-2.26 5.27-10.01 13.27-15.8 18.59a165.79 165.79 0 01-15.26 12.1l.13-.1v.1l-.06-.05-.07.05v-.1l.13.1a165.92 165.92 0 01-15.25-12.1c-5.8-5.32-13.54-13.32-15.8-18.6-2.26-5.27-2.61-9.42-2.3-10.73.56-.27 1.91-.04 3.76.54 4.65 1.4 12.12 3.64 29.53 3.64 17.4 0 24.87-2.25 29.53-3.64"
                  fill="url(#no_radialGradient-1)"
                  transform="translate(58 19.08)"
                />
                <path
                  d="M117.34 25.57c-.36.43-2.53 2.7-2.53 2.92-.01 4-.03 7.42 1.85 11.25 1.88 3.82 6.33 9.52 9.56 13.01 6.83 7.36 15.89 15.67 29.54 24.87 9.77-6.64 21.16-15.84 30.15-25.67l.78-.87c7-8.48 9.8-12.78 9.8-18.47 0-.69.2-3.26.16-4 0-.37-.92-1.44-2.77-3.21"
                  strokeOpacity=".45"
                  stroke="#050505"
                />
                <path
                  d="M62.31 139.53c9.42-3.37 11.5-8.46 13.31-13.13a80.77 80.77 0 003.27-10.19c.86-3.4 2.41-8.44 3.38-12.5 1.64-6.86 3.71-11.33 5.06-18.03 1.09-5.38 3.6-19.25 3.73-25.9.14-6.63.02-9.52.1-11.15.2-4.59 1.11-9.1 2.73-13.57m155.2 104.4c-9.43-3.36-11.5-8.45-13.32-13.12a80.77 80.77 0 01-3.27-10.2c-.86-3.4-2.4-8.43-3.38-12.49-1.64-6.87-3.71-11.34-5.06-18.03-1.08-5.38-3.6-19.26-3.73-25.9-.13-6.63-.01-9.53-.09-11.16-.2-4.58-1.12-9.1-2.74-13.56"
                  strokeOpacity=".5"
                  stroke="#000"
                  strokeLinejoin="round"
                />
                <path
                  strokeOpacity=".5"
                  stroke="#000"
                  d="M155.7 293.71c42.8-.1 72.54-1.45 89.25-4.06-1.05-32.32-1.4-52.79-1.04-61.4l.05-1.16.33-6.98c.53-10.52 1.11-22.1.7-39.2-.12-6.46.73-15.68 1.43-23.3.6-6.6 1.13-12 .84-13.65a31.6 31.6 0 011.45-1.84v-2.4c.7-.61 3.88-8.02 4.21-10.04l-.54-.26c-2.26-1.07-6.82-3.26-8.77-8.5-1.64-4.4-5.16-16.14-7.47-23.85-.8-2.66-1.45-4.84-1.83-6.06-1.48-4.77-4-15.46-4-33.09-.36-7.41-.72-12.18-1.33-15.19-.28-1.35-.6-2.33-1-3.02a2.6 2.6 0 00-1.56-1.26c-3.18-1.05-19.17-6.37-29.41-11.12a4.42 4.42 0 01-1.44-.83c-.37-.3-.84-.66-2.16-1.36-.78-.88-2.04-2-3.32-3.13-.85-.76-1.7-1.52-2.44-2.23-2.53-.5-4.64-.01-7.84.7-4.54 1-11.21 2.47-24.08 2.47-12.85 0-19.46-1.47-23.97-2.47-3.2-.71-5.32-1.2-7.91-.7-.73.7-1.6 1.46-2.47 2.2-1.32 1.14-2.62 2.26-3.5 3.28-1.14.6-1.61.96-1.98 1.25-.4.31-.69.53-1.44.81-10.23 4.75-26.25 10.08-29.63 11.2-.54.18-.98.55-1.35 1.19-.41.69-.73 1.67-1 3.02-.62 3-.97 7.78-1.34 15.19 0 17.63-2.51 28.32-4 33.1-.38 1.21-1.03 3.4-1.83 6.05-2.3 7.7-5.83 19.45-7.46 23.84-1.96 5.25-6.52 7.44-8.78 8.51l-.54.26c.34 2.02 3.5 9.43 4.2 10.05v2.4c.28.3.77.9 1.54 2.28-.37 1.2.16 6.6.76 13.2.7 7.62 1.55 16.84 1.43 23.3-.41 17.1.17 28.69.7 39.2.14 2.76.27 5.45.38 8.14.36 8.61.01 29.08-1.04 61.4 16.54 2.59 45.87 3.94 89.2 4.06z"
                />
              </g>
            </g>

            <!-- Neck and Sleeve -->
            <g>
              <path
                d="M84.16 39.3c-.47.4-.92 1.57-1.34 3.53-.47 1.98-.93 8.2-1.18 15.06 0 13.29-1.37 24.43-4.21 33.3-3.45 12.23-6.56 21.56-8.58 27.76-1.78 7.1-6.7 9.33-9.85 10.82 0 .98 2.2 6.8 3.63 9.22 9.46-3.62 11.24-8.95 13.68-15.64 2.44-6.7 6.28-23.93 8.04-28.73 1.75-4.79 3.27-12.74 4.58-20.1 2.1-13.91 1.68-16.57 1.68-23.8 0-4.81.62-9.16 2.3-14.52-1.35.42-3.26 1.05-5.03 1.65-1.97.67-2.8.7-3.72 1.46zm143.1 0c.47.4.91 1.57 1.34 3.53.46 1.98.92 8.2 1.17 15.06 0 13.29 1.37 24.43 4.22 33.3 3.44 12.23 6.55 21.56 8.57 27.76 1.78 7.1 6.7 9.33 9.85 10.82 0 .98-2.2 6.8-3.63 9.22-9.46-3.62-11.23-8.95-13.68-15.64-2.44-6.7-6.28-23.93-8.03-28.73-1.76-4.79-3.27-12.74-4.59-20.1-2.1-13.91-1.67-16.57-1.67-23.8 0-4.81-.63-9.16-2.31-14.52 1.35.42 3.26 1.05 5.03 1.65 1.98.67 2.8.7 3.72 1.46z"
                :fill="teamColors?.jersey.outline"
              />
              <path
                d="M187.4 20.25a98.58 98.58 0 003.64 3.23c.88.73 4.31 4.05 5.09 5.14 0 7.58-.46 9.88-6.08 17.5-8.33 11.3-24.26 24.13-34.29 30.9-10.32-6.75-26.05-19.6-34.38-30.9-5.63-7.62-6.08-9.92-6.08-17.5.77-1.09 4.2-4.4 5.08-5.14.88-.74 1.97-1.68 3.65-3.23 6.27-1.3 8.8 2.88 30.34 3.05h.63c21.64-.16 26.12-4.34 32.4-3.05zm1.38 5.26c-.57-.27-1.92-.04-3.76.55-4.66 1.38-12.12 3.63-29.53 3.63-17.41 0-24.88-2.25-29.53-3.63-1.85-.6-3.2-.82-3.77-.55-.3 1.31.05 5.47 2.3 10.74 2.27 5.27 10.02 13.27 15.8 18.59 3.87 3.54 8.95 7.58 15.26 12.1l-.13-.09v.1l.07-.05.06.04v-.09l.57-.4a166 166 0 0014.13-11.22l.43-.4c5.79-5.31 13.54-13.31 15.8-18.58 2.25-5.27 2.6-9.43 2.3-10.74z"
                :fill="teamColors?.jersey.outline"
              />
            </g>
            <!-- Squares -->
            <g
              v-if="teamColors?.jersey.squares"
              :fill="teamColors?.jersey.squares"
              mask="url(#no_mask-1)"
            >
              <path
                d="M132.2 27.8c9.11-.44 19.1-1.5 29.5 1.5.19 4.03-.39 10.58.82 18.41-.51 8.27.3 16.73-1.4 24.17-4.66-.36-6.67.67-19.18 0-13.32-.7-21.47.07-24.36-.48 3.36-10.73 2.3-21.13 2.1-30.4 4.3-4.08 8.67-8.46 12.51-13.2zm-98.55 1.73c13.63-1.61 23.71 1.3 31.38.27 1.47 1.8 5.16 5.9 6.95 7.59.53 12.05-2.94 23.65-2.94 34.01-9.28-1.1-22.9-.84-40.81.87 1.82-5.95 3.78-17.66 4.94-26.91.57-4.52.48-12.17.48-15.83z"
              />
              <path
                d="M69.04 71.4c11.84-1.03 26.13.5 48.54 0 1.73 12.18 1.73 28.26 1.73 40.44-14.05-.42-31.13-.3-51.42 0 0-12.33.19-27.11 1.15-40.44z"
              />
              <path
                d="M24.56 113.58c22.8-2.31 31.77-2.31 43.33-2.31 1.64 18.26.06 24.24 4.04 45.06H31.5c1.51-15.59-6.93-22.01-6.93-42.75zm138.08 0c-22.8-2.31-32.42-2.31-43.33-2.31-1.29 16.46 0 22.47-4.04 45.06h40.44c-1.51-15.59 6.93-22.01 6.93-42.75z"
              />
              <path
                d="M71.93 156.33c15-.88 24.58-.88 43.34 0v43.34c-3.98.54-12.73 0-21.4-.48-8.33-.46-17.47.11-22.51.48 0-11.38.57-32.5.57-43.34zm43.34 43.34c5 .97 9.75.85 16.76.85 5.14 0 6.93.1 17.9-2.59-2.18 7.64 1.39 12.3 1.77 20.57.08 1.7.2 8.66.34 10.4.44 5.36.58 10.58 1.36 13.52-5.98 0-12.62 1.33-16.55 1.2-12.9-.4-6.63-1.2-21.58-.62-1.4-19.86 0-36.44 0-43.33zm-79.16.57c3.2.76 7.01-2.04 14.11-.57 9.23 1.9 10.33.76 21.14 0-.58 11.07.57 29.16 1.15 44.49-7.1.36-12.83.32-20.41.32-9.2 0-6.92-2.06-15.99-2.06-8.78-15.58 9.07-31 0-42.18z"
              />
              <path
                d="M72.51 243.58c8.23.58 13.76-.83 20.77-1.04 8.1-.24 13.81 1.04 21.99.46.29 6.8.56 20.18.64 30.6-10.6.2-33.37.1-43.6-.11.12-11.13-.22-20.74.2-29.91zM24.34 85.84c-.45 12.2-.37 21.45.22 27.74-2.65.06-6.15.21-10.5.45 5.01-5.53 8.45-23.08 10.28-28.2zM8.38 157.96a181.88 181.88 0 0123.1-1.63c-3.58 20.66 6.24 31.16 4.67 43.85-13.54-.88-18.04-.51-26.99-.51-.27-4.97-.63-12.45-.78-19.82-.19-9.18-.12-18.18 0-21.89zm.86 84.46h26.94c2.92 12.94-.64 20-2.59 29.66a282.22 282.22 0 01-25.12-2.37l.77-27.29zM160.82 71.04l6.02-.19.91 3.11c.8 2.55 1.87 5.87 2.24 7.37 1.63 6.5 3 11.19 3.87 14.47 2.47 9.3 4.92 15.47 7.6 18.3-7.52.22-13.79.05-18.82-.52 1.27-5-1.82-16.4-1.82-26.58V71.04zm-5.1 85.3h31.33c-.09 1.96.17 7.42.1 13.77-.03 3.44-.02 7.23-.1 10.9-.18 7.7-.5 14.87-.65 16.84-18.12-.34-30.18-.28-36.36.08 1.73-23.42 10.1-24 5.67-41.6zm-1.97 86.08c7.13-.8 17.91-2.46 32.34-4.97 0 5.64.64 25.78.87 32.3a464.9 464.9 0 01-17.26 1.82c-4.63.39-9.5.66-14 .9-.44-11.22.14-22.56-1.95-30.05zM130.78 5.52c.3 1.3-.05 5.46-2.3 10.73-2.26 5.27-10.01 13.27-15.8 18.59a165.79 165.79 0 01-15.26 12.1l.13-.1v.1l-.06-.04-.07.04v-.1l.13.1a165.92 165.92 0 01-15.25-12.1c-5.8-5.32-13.54-13.32-15.8-18.6-2.26-5.26-2.61-9.42-2.3-10.73.56-.27 1.91-.04 3.76.55 4.65 1.38 12.12 3.63 29.53 3.63 17.4 0 24.87-2.25 29.53-3.63 1.84-.6 3.2-.82 3.76-.55z"
              />
            </g>

            <!-- Stripes -->
            <g
              v-if="teamColors?.jersey.verticalStripe"
              :fill="teamColors?.jersey.verticalStripe"
              mask="url(#no_mask-1)"
            >
              <path
                d="M194.52 110c-.67 2.53-3.3 8.65-4.11 9.71v2.42c-.19.15-.7.8-1.56 1.93.8 2.6-2.4 24.5-2.17 36.64.53 21.6-.54 34.41-1.08 47.37-.36 8.65-.1 28.78.97 61.34a255.3 255.3 0 01-15.6 1.7c-2.96-46.72.17-78.51.17-89.11v-47.5c0-19.76 9.66-31.2 12.53-38.29 1.58 8.36 5.78 11.57 10.85 13.8zM1 110c.67 2.53 3.3 8.65 4.12 9.71v2.42c.18.15.7.8 1.55 1.93-.8 2.6 2.4 24.5 2.17 36.64-.52 21.6.54 34.41 1.08 47.37.36 8.65.1 28.78-.97 61.34a255.3 255.3 0 0015.6 1.7c2.96-46.72-.17-78.51-.17-89.11v-47.5c0-19.76-9.65-31.2-12.53-38.29-1.57 8.36-5.77 11.57-10.85 13.8zm84.87-60.59c-.1 7.97 0 17.36 0 26.98 0 41.85.15 43.28 1.3 84.08.42 14.46.42 29.28.28 44.25-.16 17.26.5 34.72.42 52.03-.04 7.56-.32 18.92-.85 34.1H52.04c-.03-6.42.27-17.83.9-34.24.74-19.6.08-37.4.17-53.15.1-16.9.94-31.47.71-43.43-.82-43.72-1.3-61.6-1.3-83.86 0-13.36 1.97-44.3 3.78-67.17-.29 6.3 1.17 10.1 3.6 13.95a87.45 87.45 0 007.08 9.09c3.91 4.54 9.44 9.97 18.89 17.37zm23.68.15c.1 7.98 0 17.2 0 26.83 0 41.85-.16 43.28-1.31 84.08-.41 14.46-.41 29.28-.27 44.25.15 17.26-.51 34.72-.42 52.03.04 7.56.32 18.92.84 34.1h34.98c.03-6.42-.27-17.83-.9-34.24-.74-19.6-.07-37.4-.17-53.15-.1-16.9-.93-31.47-.7-43.43.82-43.72 1.3-61.6 1.3-83.86 0-13.36-1.98-44.3-3.78-67.17.27 6.23-1.16 9.67-3.29 13.48-1.26 2.25-4.04 6.03-7.38 9.64-4.03 4.39-9.53 9.92-18.9 17.44z"
              />
            </g>

            <!-- Horizontal Stripes -->
            <g
              v-if="teamColors?.jersey.horizontalStripe"
              :fill="teamColors?.jersey.horizontalStripe"
              mask="url(#no_mask-1)"
            >
              <path
                d="M194.52 110c-.67 2.53-3.3 8.65-4.11 9.71v2.42c-.19.15-.7.8-1.56 1.93.8 2.6-2.4 24.5-2.17 36.64.53 21.6-.54 34.41-1.08 47.37-.36 8.65-.1 28.78.97 61.34a255.3 255.3 0 01-15.6 1.7c-2.96-46.72.17-78.51.17-89.11v-47.5c0-19.76 9.66-31.2 12.53-38.29 1.58 8.36 5.78 11.57 10.85 13.8zM1 110c.67 2.53 3.3 8.65 4.12 9.71v2.42c.18.15.7.8 1.55 1.93-.8 2.6 2.4 24.5 2.17 36.64-.52 21.6.54 34.41 1.08 47.37.36 8.65.1 28.78-.97 61.34a255.3 255.3 0 0015.6 1.7c2.96-46.72-.17-78.51-.17-89.11v-47.5c0-19.76-9.65-31.2-12.53-38.29-1.57 8.36-5.77 11.57-10.85 13.8zm84.87-60.59c-.1 7.97 0 17.36 0 26.98 0 41.85.15 43.28 1.3 84.08.42 14.46.42 29.28.28 44.25-.16 17.26.5 34.72.42 52.03-.04 7.56-.32 18.92-.85 34.1H52.04c-.03-6.42.27-17.83.9-34.24.74-19.6.08-37.4.17-53.15.1-16.9.94-31.47.71-43.43-.82-43.72-1.3-61.6-1.3-83.86 0-13.36 1.97-44.3 3.78-67.17-.29 6.3 1.17 10.1 3.6 13.95a87.45 87.45 0 007.08 9.09c3.91 4.54 9.44 9.97 18.89 17.37zm23.68.15c.1 7.98 0 17.2 0 26.83 0 41.85-.16 43.28-1.31 84.08-.41 14.46-.41 29.28-.27 44.25.15 17.26-.51 34.72-.42 52.03.04 7.56.32 18.92.84 34.1h34.98c.03-6.42-.27-17.83-.9-34.24-.74-19.6-.07-37.4-.17-53.15-.1-16.9-.93-31.47-.7-43.43.82-43.72 1.3-61.6 1.3-83.86 0-13.36-1.98-44.3-3.78-67.17.27 6.23-1.16 9.67-3.29 13.48-1.26 2.25-4.04 6.03-7.38 9.64-4.03 4.39-9.53 9.92-18.9 17.44z"
              />
            </g>

            <!-- Jersey Split -->
            <path
              v-if="teamColors?.jersey.split"
              :fill="teamColors?.jersey.split"
              d="M180.61 85.52c-1.84-6.08-3.57-12-4.3-14.36-1.47-4.75-3.95-15.4-3.95-32.95-.72-14.59-1.4-19-4.01-19.87-2.61-.87-19.02-6.32-29.41-11.18a16.2 16.2 0 00-4-1.25c-.78-1.3-3.85-3.56-5.7-5.37-5.94-1.3-9.23 3.06-31.52 3.07C75.44 3.6 72.15-.76 66.2.54c-1.85 1.81-4.92 4.07-5.7 5.37a16.2 16.2 0 00-4 1.25c-10.39 4.86-26.8 10.31-29.4 11.18-2.61.88-3.3 5.28-4.02 19.87 0 17.55-2.48 28.2-3.94 32.95-.75 2.41-2.55 8.54-4.43 14.77 15.23-2.87 28.04 6.49 57.72 6.49 22.58 0 38.55-1.67 59.46-1.67 21.9 0 38.9-2.17 48.72-5.23z"
              mask="url(#no_mask-1)"
            />
          </g>
        </g>
      </svg>
    </div>

    <div :class="[classes.overlay]">
      <img :class="classes.overlayImg" :src="overlay" />
    </div>
  </div>
</template>
<script lang="ts">
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { createUseStyles } from "@fresh8/vue-jss/src";

import { computed, defineComponent, PropType } from "vue";
import { injectTemplateSize } from "@fresh8/ad-data-composition/src/useTemplateSize";
import { NoSleeveOverlay as overlay } from "../overlays/jerseys";
import { injectTeamColors } from "../../../lib/teamBranding";

const useStyles = createUseStyles({
  body: {
    width: "100%",
    height: "100%",
    alignSelf: "baseline",
    display: "flex"
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: props => props.padding
  },
  overlayImg: {
    width: "100%",
    height: "100%"
  },
  container: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderStyle: "solid",
    borderWidth: props => props.borderWidth,
    background: "white",
    borderRadius: "9001px",
    margin: "0",
    borderColor: props => props.borderColor,
    boxShadow: "0 2px 8px -2px rgba(0,0,0,0.16), 0 1px 2px rgba(0,0,0,.3)",
    maxWidth: "32px",
    position: "relative",
    overflow: "hidden",
    padding: props => props.padding
  }
});

export default defineComponent({
  name: "NoSleeveJersey",
  props: {
    borderWidth: {
      type: String,
      required: false,
      default: "1px"
    },
    hideBoxShadow: {
      type: Boolean,
      required: false,
      default: false
    },
    homeOrAwayTeam: {
      type: String as PropType<"home" | "away">,
      required: true
    },
    padding: {
      type: String,
      required: false,
      default: "2px"
    }
  },
  setup(props) {
    const brandContext = injectBrand();
    const template = injectTemplateSize();

    const teamColorsContext = injectTeamColors();

    const teamColors = computed(
      () => teamColorsContext.colors.value[props.homeOrAwayTeam]
    );

    const borderColor = computed(() => {
      if (
        brandContext?.brand.value?.adTemplate?.team?.useTeamColors &&
        teamColors.value?.banner.background
      ) {
        return teamColors.value?.banner.background;
      } else {
        return brandContext?.teamBranding.value.badge.borderColor;
      }
    });

    const reactiveStyles = computed(() => ({
      borderWidth: props.borderWidth,
      borderColor:
        borderColor.value || brandContext?.teamBranding.value.badge.borderColor,
      hideBoxShadow: props.hideBoxShadow,
      padding: props.padding
    }));

    const classes = useStyles(reactiveStyles);

    const sleevesAvailable = computed(() => {
      return teamColors.value?.jersey.shirtType !== "no_sleeves";
    });

    return {
      sleevesAvailable,
      teamColors,
      overlay,
      classes,
      layoutClass: computed(() => template?.size.value?.name)
    };
  }
});
</script>
